import { endPoints, requestType } from "../lib/Variable";
import Api from "./index";

const getUnreadNotificationCount = (id) => {
  return Api(
    `${endPoints.getUnreadNotificationCount}/${id}`,
    null,
    requestType.GET
  );
};

const getNotifications = (id) => {
  return Api(`${endPoints.getNotifications}/${id}`, null, requestType.GET);
};

export { getUnreadNotificationCount, getNotifications };
